






import { defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";

export default defineComponent({
  name: "AvailableContentCount",
  props: {
    countName: { type: String, required: false, default: $t("post") },
    contentCount: { type: Number, required: false, default: 0 },
  },
});
